/*
 * @Descripttion:
 * @version:
 * @Author: Raoxf
 * @Date: 2022-05-28 21:57:18
 * @LastEditors: Raoxf
 * @LastEditTime: 2023-04-08 08:49:19
 */
const STATUS = {
  1: "待入驻",
  2: "已入驻",
};
const STATUSTYPE = {
  3: "删除",
};
export default (Vue) => {
  let colomnList = [
    {
      title: "商户名称",
      key: "name",
      minWidth: 200,
      align: "center",
    },
    {
      title: "法人姓名",
      key: "legalPersonName",
      align: "center",
      minWidth: 120,
    },
    {
      title: "法人手机号",
      key: "legalPersonPhone",
      minWidth: 150,
      align: "center",
    },
    {
      title: "入驻时间",
      key: "createDt",
      minWidth: 180,
      align: "center",
    },
    {
      title: "审核状态",
      key: "state",
      align: "center",
      minWidth: 120,
      render: (h, { row }) => {
        const map = { 0: "未入驻", 1: "已入驻", 2: "拒绝" };
        const color =
          String(row.state) === "1"
            ? "success"
            : String(row.state) === "2"
            ? "error"
            : "warning";
        return h("Tag", { props: { color } }, map[row.state] || "-");
      },
    },
    {
      title: "接单状态",
      key: "isAcceptOrders",
      align: "center",
      minWidth: 120,
      render: (h, { row }) => {
        const isAccept =
          String(row.isAcceptOrders) === "1" || row.isAcceptOrders === "";
        const color = isAccept ? "success" : "default";
        return h("Tag", { props: { color } }, isAccept ? "能" : "不能");
      },
    },
  ];
  if (window.userInfo.companyId) {
    return colomnList;
  } else {
    return [
      ...colomnList,
      {
        title: "操作",
        key: "action",
        fixed: "right",
        align: "center",
        width: 220,
        render: (h, { row }) => {
          return h("div", [
            // 审核按钮，仅未入驻时显示
            // String(row.state) === "0"
            //   ? h(
            //       "Button",
            //       {
            //         props: {
            //           type: "text",
            //           size: "small",
            //         },
            //         style: {
            //           color: "#3091FF",
            //           marginRight: "8px",
            //         },
            //         on: {
            //           click: () => {
            //             Vue.companyReviewFormData = {
            //               companyId: row.companyId,
            //               state: "",
            //               reason: "",
            //             };
            //             Vue.showCompanyReviewDialog = true;
            //           },
            //         },
            //       },
            //       "审核"
            //     )
            //   : null,
            // 接单审核/切换按钮
            h(
              "Button",
              {
                props: {
                  type: "text",
                  size: "small",
                },
                style: {
                  color: "#3091FF",
                  marginRight: "8px",
                },
                on: {
                  click: () => {
                    const next =
                      String(row.isAcceptOrders) === "1" ||
                      row.isAcceptOrders === ""
                        ? "0"
                        : "1";
                    const text = next === "1" ? "能接单" : "不能接单";
                    Vue.$confirm(`确认设置为${text}?`, "提示", {
                      confirmButtonText: "确定",
                      cancelButtonText: "取消",
                      type: "warning",
                    })
                      .then(async () => {
                        await Vue.$post("/user/updateIsAcceptOrders", {
                          companyId: row.id,
                          isAcceptOrders: next,
                        });
                        Vue.$Notice.success({ title: "更新成功" });
                        Vue.getCompanyList();
                      })
                      .catch(() => {});
                  },
                },
              },
              "接单审核"
            ),
            h(
              "Button",
              {
                props: {
                  type: "text",
                  size: "small",
                },
                style: {
                  color: "#3091FF",
                },
                on: {
                  click: () => {
                    Vue.addInfo = row;
                    Vue.addMerchantDialog = true;
                  },
                },
              },
              "编辑"
            ),
            h(
              "Button",
              {
                props: {
                  type: "text",
                  size: "small",
                },
                style: {
                  color: "#3091FF",
                },
                on: {
                  click: () => {
                    Vue.$confirm("确认删除?", "提示", {
                      confirmButtonText: "确定",
                      cancelButtonText: "取消",
                      type: "warning",
                    })
                      .then(async () => {
                        let data = await this.$get("/company/delete", {
                          companyId: row.companyId,
                        });
                        this.$message({
                          type: "info",
                          message: "删除成功",
                        });
                      })
                      .catch(() => {
                        this.$message({
                          type: "info",
                          message: "已取消删除",
                        });
                      });
                  },
                },
              },
              "删除"
            ),
          ]);
        },
      },
    ];
  }
};
